export default {
    path: '/modules/invoice',
    component: () => import('@/modules/invoice-manage/pages/index.vue'),
    children: [
        {
            // path: 'view/:client_id?',
            path:'view',
            component: () => import('@/modules/invoice-manage/pages/details.vue'),
            meta: {
                pageTitle: '查看',
                parent: '/modules/invoice/list',
            }
        },
        {
            path: 'list',
            component: () => import('@/modules/invoice-manage/pages/list.vue'),
            meta: {
                pageTitle: '发票管理列表',
            }
        },
        {
            path: 'operateLog',
            component: () => import('@/modules/invoice-manage/pages/operateLog.vue'),
            meta: {
                pageTitle: '操作日志',
            }
        },

    ]
};
